var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EAEDF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 30,
    height: 15,
    rx: 2,
    fill: "#0F91AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85 16V23H10.99V20.6H12.35C14.01 20.6 15.34 20.08 15.34 18.3C15.34 16.52 14.01 16 12.35 16H9.85ZM14.18 18.3C14.18 19.32 13.37 19.56 12.41 19.56H10.99V17.04H12.41C13.38 17.04 14.18 17.28 14.18 18.3ZM17.6209 23V18.64C17.6209 18.39 17.6209 18.12 17.6109 17.88L21.3809 23H22.4509V16H21.3109V20.35C21.3109 20.61 21.3109 20.88 21.3209 21.12L17.5509 16H16.4809V23H17.6209ZM23.7169 19.5C23.7169 22.11 25.5969 23.13 27.5369 23.13C28.3069 23.13 29.0969 22.96 29.7669 22.66V19.24H28.6569V21.89C28.3769 22.02 27.9969 22.09 27.6069 22.09C26.3369 22.09 24.8869 21.5 24.8869 19.5C24.8869 17.67 26.2669 16.92 27.6369 16.92C28.3569 16.92 29.0669 17.1 29.5969 17.44V16.33C28.9669 16.03 28.2269 15.87 27.4769 15.87C25.5969 15.87 23.7169 17.03 23.7169 19.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.eb76d119a74572721aa9dafd750ad8fc.svg";
export { ForwardRef as ReactComponent };